import React, { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Desktop } from '@constants/mediaQuery'
import EventSubTitleForWeb from '@pages/Event/components/EventSubTitleForWeb'
import styled from 'styled-components'
import { useAppSelector } from '@store/selectors/utils'
import { Link } from 'react-router-dom'
import NavigateEventButton from '@pages/Event/components/NavigateEventButton'
import InstallBottomSheet from '@components/simulated-trading/InstallBottomSheet'
import V2Layout from '@layouts/V2Layout'
import CommonButton from '@pages/Event/simulate/v2/component/CommonButton'
import BottomButtonFixer from '@components/v2/BottomButtonFixer'
import { AVAILABLE_MY_LINK_VERSION } from '@constants/index'
import usePostMessage from '@hooks/usePostMessage'
import { useScrollBlock } from '@hooks/useScrollBlock'
import { isMobile } from 'react-device-detect'
import DownloadSheet from '@pages/Event/simulate/v1/EventCompletePage/components/DownloadSheet'
import V2Notice from '@pages/Event/simulate/v2/component/V2Notice'
import Footer from '@components/layout/Footer'
import HeaderBack from '../component/HeaderBack'

const SubTitleWrapper = styled.div`
  margin-top: 78px;
  z-index: 3;
`

const Image = styled.img`
  width: 100%;
  object-fit: contain;
  object-position: top;
  height: auto;
  display: block;
  margin: 0;
  border: none;
  &:nth-child(2) {
    margin: -2px 0 0;
  }
`
const GuideBox = styled.article`
  width: 100%;
  display: flex;
  max-width: 500px;
  margin: 0 auto;
  justify-content: center;
  background-color: #19191b;
  padding: 0 32px 64px;
  @media screen and (max-width: 500px) {
    padding: 0 24px 40px;
  }
`
const GuideBanner = styled(Link)`
  cursor: pointer;
  display: flex;
  > img {
    width: 100%;
  }
`

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  margin: 0 auto;
`
const WebButtonWrapper = styled.div`
  display: flex;
  width: 100vw;
  position: fixed;
  bottom: 0;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
  z-index: 2;
  background-color: white;
`
const WebButton = styled.button`
  height: 56px;
  width: 100%;
  max-width: 800px;
  background-color: #0e6dfb;
  border-radius: 12px;
  cursor: pointer;
  > span {
    font-family: Pretendard400, sans-serif;
    line-height: 19px;
    font-size: 16px;
    color: white;
  }
`
const LayoutStyle = styled.div<{ isMobileSize: boolean }>`
  display: flex;
  flex-direction: column;
  padding-bottom: ${({ isMobileSize }) => (isMobileSize ? 0 : 104)}px;
`

const V2CompletePage = () => {
  const isMobileSize = useMediaQuery({ query: `(max-width: ${Desktop}px)` })
  const { isFromApp } = useAppSelector((state) => state.entryReducer)
  const [openBottomSheet, setOpenBottomSheet] = useState(false)
  const appVersion = localStorage.getItem('version')
  const { postMessageHandler } = usePostMessage()
  const [blockScroll, allowScroll] = useScrollBlock()

  const navigateTabLink = () => {
    if (appVersion && Number(appVersion) >= AVAILABLE_MY_LINK_VERSION) {
      return 'toMyTab'
    } else {
      return 'toInvestmentTab'
    }
  }
  const handleBackButton = () => {
    postMessageHandler({
      action: 'close',
    })
  }

  const onClickToInvest = () => {
    const formatted = {
      action: navigateTabLink(),
    }
    if (isFromApp) {
      postMessageHandler(formatted)
    } else {
      setOpenBottomSheet(true)
    }
  }
  useEffect(() => {
    if (openBottomSheet) {
      blockScroll()
    } else {
      allowScroll()
    }
    return () => allowScroll()
  }, [openBottomSheet])

  return (
    <LayoutStyle isMobileSize={isMobileSize}>
      {openBottomSheet && (
        <>
          {isMobile ? (
            <DownloadSheet
              isOpen={openBottomSheet}
              handleClose={() => setOpenBottomSheet(false)}
            />
          ) : (
            <InstallBottomSheet onClose={() => setOpenBottomSheet(false)} />
          )}
        </>
      )}
      {!isMobileSize && (
        <SubTitleWrapper>
          <EventSubTitleForWeb
            title={
              '공모주게임 시즌2 종료! 최대 35만원의 최종 상금 주인공은 누구?'
            }
            description={'~ 5월 31일'}
          />
        </SubTitleWrapper>
      )}
      <V2Layout
        paddingTop={!isMobileSize ? 1 : 78}
        paddingBottom={isMobileSize ? 88 : -1}
        LeftComponent={
          isFromApp ? <HeaderBack onClick={handleBackButton} /> : null
        }
      >
        <Wrapper>
          <Image
            src={'/images/simulate-v2/season2-complete-1.png'}
            alt={'season-2-information-1'}
          />
          <Image
            src={'/images/simulate-v2/season2-complete-2.png'}
            alt={'season-2-information-2'}
          />
          <Image
            src={
              isFromApp
                ? '/images/simulate-v2/season2-complete-3.png'
                : '/images/simulate-v2/season2-complete-3-web.png'
            }
            alt={'season-2-information-2'}
          />
          <GuideBox>
            <GuideBanner to={'/guide?hasHeader=true'}>
              <img
                src={'/images/simulateUpdate/guide-banner.png'}
                alt={'guide'}
              />
            </GuideBanner>
          </GuideBox>
          {/*  유의사항 */}
          <V2Notice />
          {!isMobileSize && <NavigateEventButton margin={'32px 0 54px'} />}
          {isMobileSize && (
            <BottomButtonFixer hasBorder={false}>
              <CommonButton
                id={'event_160_03_main_startinvest_btn_click'}
                onClick={onClickToInvest}
                buttonText={
                  isFromApp
                    ? '간편투자하고 혜택 수령하기'
                    : '일육공앱에서 혜택 수령하기'
                }
                disabled={false}
              />
            </BottomButtonFixer>
          )}
        </Wrapper>
      </V2Layout>
      {!isMobileSize && <Footer />}

      {!isMobileSize && (
        <WebButtonWrapper>
          <WebButton onClick={onClickToInvest}>
            <span>일육공앱에서 혜택 수령하기</span>
          </WebButton>
        </WebButtonWrapper>
      )}
    </LayoutStyle>
  )
}

export default V2CompletePage
